import React, { useContext, useEffect } from "react";
import "./Success_speaks.css";
import Success_speaks_card from "./success_speaks_card/Success_speaks_card";
import { GetSuccessSpeaks } from "../../features/website/Slice";
import { useDispatch, useSelector } from "react-redux";
import ReactStars from "react-rating-stars-component";
import { IDS } from "../../../utils/IDS";
import { Context } from "../../../utils/context";

function SuccessSpeaks() {
  const dispatch = useDispatch();
  const cards = Array.from({ length: 20 });

  const successSpeaks = useSelector(
    (state) => state?.website?.GetSuccessSpeaks?.all_success_speaks,
  );

  console.log(successSpeaks, "successSpeaks");

  const { language, setLanguage } = useContext(Context);

  useEffect(() => {
    loadSuccessSpeaks({});
  }, [dispatch, language]);

  const loadSuccessSpeaks = async () => {
    await dispatch(GetSuccessSpeaks({ language }));
  };

  const ratingChanged = (newRating) => {
    console.log(newRating);
  };

  const cardClasses = [
    "brown_comment_card",
    "green_comment_card",
    "blue_comment_card",
  ];

  return (
    <div className="Success_speaks">
      <div className="container">
        <div className="heading_holder">
          <h2>
            {language == 1 ? "Success " : "Le succès "}
            <span>{language == 1 ? "Speaks" : "parle"}</span>
            {language == 1 ? " for Itself" : " de lui-même"}
          </h2>

          <p>
            {language == 1
              ? "See how our students built their future abroad."
              : "Découvrez comment nos étudiants ont construit leur avenir à l’étranger."}
          </p>
        </div>
        {/* ================= DESKTOP VIEW ================= */}
        <div className="desktop_view_success_speak">
          <div className="scatter_area">
            {Array.isArray(successSpeaks) &&
              successSpeaks.map((value, i) => (
                <div
                  key={value?.id || i}
                  className="scatter_card_wrapper"
                  style={{
                    "--x": `${(i % 8) * 260}px`,
                    "--y": `${Math.max((i % 3) * 60 - 60, 0)}px`, // ✅ FIX
                    "--rotate": `${((i % 5) - 2) * 6}deg`,
                  }}
                >
                  <section
                    className={`Success_speaks_card ${
                      cardClasses[i % cardClasses.length]
                    }`}
                  >
                    <div className="profile_text_img_holder">
                      <div className="img_holder">
                        <img
                          src={IDS?.IMG_URL + value?.SuccessSpeak?.image}
                          alt="user"
                          className="user_img"
                        />
                      </div>

                      <div className="text_holder">
                        <div className="name_text_holder">
                          <h4>{value?.name}</h4>
                          <p>{`${value?.college} – ${value?.college}`}</p>
                        </div>

                        <div className="rating_star_holder">
                          <ReactStars
                            count={5}
                            value={value?.rating || 5}
                            size={20}
                            activeColor="#ffd700"
                            color="#fff"
                            edit={false}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="comment_text_holder">
                      <p>{value?.description}</p>
                    </div>
                  </section>
                </div>
              ))}
          </div>
        </div>

        {/* ================= MOBILE VIEW ================= */}
        <div className="mobile_view_success_speak">
          <div className="row justify-content-center">
            {Array.isArray(successSpeaks) &&
              successSpeaks?.map((value, i) => (
                <div
                  key={value?.id || i}
                  className="col-md-6 col-sm-6 col-12 mb-3"
                >
                  <section
                    className={`Success_speaks_card ${
                      cardClasses[i % cardClasses.length]
                    }`}
                  >
                    <div className="profile_text_img_holder">
                      <div className="img_holder">
                        <img
                          src="/assets/images/home/success_speaks/user_1.webp"
                          alt="user"
                          className="user_img"
                        />
                      </div>

                      <div className="text_holder">
                        <div className="name_text_holder">
                          <h4>{value?.name}</h4>
                          <p>{`${value?.college} – ${value?.college}`}</p>
                        </div>

                        <div className="rating_star_holder">
                          <ReactStars
                            count={5}
                            value={value?.rating || 5}
                            onChange={ratingChanged}
                            size={20}
                            activeColor="#ffd700"
                            color="#fff"
                            edit={false}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="comment_text_holder">
                      <p>{value?.description}</p>
                    </div>
                  </section>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SuccessSpeaks;
